import { useStorage } from "@vueuse/core";
import { reactive } from "vue";

const dictationOn = useStorage("dictation_on", false);
const dictationSpeed = useStorage("dictation_speed", 1);

/** @type {readonly [1, 1.25, 1.5, 2]} */
const DICTATION_SPEEDS = [1, 1.25, 1.5, 2];

export const useChatStore = reactive({
    dictationOn,
    toggleDictation() {
        this.dictationOn = !this.dictationOn;
    },
    // Id of the assistant message whose audio is playing right now, or null when nothing is reading.
    // Drives the per-message "reading" state (selected + pause icon) in the reaction bar.
    /** @type {string | null} */
    dictationPlayingMessageId: null,
    /** @param {string | null} messageId */
    setDictationPlayingMessageId(messageId) {
        this.dictationPlayingMessageId = messageId;
    },
    dictationSpeed,
    DICTATION_SPEEDS,
    cycleDictationSpeed() {
        const currentIndex = DICTATION_SPEEDS.indexOf(this.dictationSpeed);
        const nextIndex = (currentIndex + 1) % DICTATION_SPEEDS.length;
        this.dictationSpeed = DICTATION_SPEEDS[nextIndex];
    },
    files: [],
    addFile(file) {
        this.files.push(file);
    },
    removeFile(id) {
        this.files = this.files.filter((file) => file.id !== id);
    },
    removeAttachment(file) {
        this.files = this.files.filter((entry) => {
            if ("id" in file) {
                return !("id" in entry) || entry.id !== file.id;
            }
            if ("draftId" in file) {
                return !("draftId" in entry) || entry.draftId !== file.draftId;
            }
            return entry !== file;
        });
    },
    removeDraftFile(file) {
        this.files = this.files.filter((entry) => entry !== file);
    },
    removeFileByName(name) {
        this.files = this.files.filter((file) => file.name !== name);
    },
    removeAllFiles() {
        this.files = [];
    },
    rolePlay: {},
    setRolePlay(rolePlay) {
        this.rolePlay = rolePlay;
    },
});
